import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { IQueryReportResponse, IQueryReportRequest, IQueryReportsFacilityRequest } from './query-report';
import { HttpHelper } from '../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class QueryReportService {

    private _queryreporturl = `api/queryreport`;
    
    constructor(private httpHelper: HttpHelper) { }

    getFacilityListReport(request: any): Observable<IQueryReportResponse[]> {
         return this.httpHelper.post(`${this._queryreporturl}/queryReportsGenerate`, request);
    }
    saveLocids(requestLocid: IQueryReportsFacilityRequest):Observable<IQueryReportResponse>{
        return this.httpHelper.post(`${this._queryreporturl}/saveLocidList`, requestLocid)
    }
    generateGraphs(request:any) :Observable<any>{
        return this.httpHelper.post(`${this._queryreporturl}/queryReportGraphs`, request);
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
            
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
   }
}


/** WEBPACK FOOTER **
 ** ./app/query-reports/query-report.service.ts
 **/